import LazyImage from "@Components/Image";
import getImagePath from "@Utils/getImagePath";
import wrapperHOC from "@Utils/wrapperHOC";
import { CHINA_PAYMENT_LOGOS } from "constants/configConstants";
import classes from "./ChinaPaymentLogos.module.scss";

interface IChinaPaymentLogos {
  /**
   * `row` — marks on one wrapping flex line (footer desktop, PDP Mode of Payment).
   * `grid` — same marks, wrapping 2x2 at 650px and below (footer mweb card).
   */
  layout?: "row" | "grid";
  dataTestIdPrefix?: string;
}

const ChinaPaymentLogos = ({
  layout = "row",
  dataTestIdPrefix = "footer-payment",
}: IChinaPaymentLogos) => (
  <div className={layout === "grid" ? classes.grid : classes.row}>
    {CHINA_PAYMENT_LOGOS.map((logo) => (
      <LazyImage
        key={logo.id}
        dataTestId={`${dataTestIdPrefix}-${logo.id}`}
        src={getImagePath(logo.src)}
        alt={logo.id}
        className={classes.logo}
        style={{ maxHeight: `${logo.maxHeight}px` }}
        width={logo.width}
        height={logo.height}
      />
    ))}
  </div>
);

export default wrapperHOC(ChinaPaymentLogos, {
  componentName: "ChinaPaymentLogos",
  showForChina: true,
  showForWhiteLable: false,
});
